module.exports = __webpack_public_path__ + "static/img/ygfc2.2d0c695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/ygfc2.png
// module id = bsoH
// module chunks = 2